module.exports = __webpack_public_path__ + "img/agent-orchestration.d9048323.png";